/* Relax & Wax theme scripts. Prices shown in the bag come straight from Shopify,
so wholesale and volume discounts always match checkout. */
(function () {
'use strict';
var RW = window.RW || {};
var routes = RW.routes || {};
function money(cents) {
try {
return new Intl.NumberFormat(RW.locale || 'en-US', { style: 'currency', currency: RW.currency || 'USD' }).format((cents || 0) / 100);
} catch (e) {
return '$' + ((cents || 0) / 100).toFixed(2);
}
}
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function $(sel, root) { return (root || document).querySelector(sel); }
function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
var toastTimer;
function toast(msg) {
var el = $('[data-rw-toast]');
if (!el) return;
el.textContent = msg;
el.classList.add('is-show');
clearTimeout(toastTimer);
toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 2600);
}
var lastFocus;
function openDrawer(id) {
var d = document.getElementById(id);
if (!d) return;
lastFocus = document.activeElement;
d.classList.add('is-open');
d.setAttribute('aria-hidden', 'false');
document.body.classList.add('rw-lock');
var f = d.querySelector('button, a');
if (f) f.focus();
}
function closeDrawer(id) {
var d = document.getElementById(id);
if (!d) return;
d.classList.remove('is-open');
d.setAttribute('aria-hidden', 'true');
document.body.classList.remove('rw-lock');
if (lastFocus) lastFocus.focus();
}
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape') { closeDrawer('rw-cart-drawer'); closeDrawer('rw-menu-drawer'); }
});
function initAnnouncements() {
var items = $all('.rw-announce__item');
if (items.length < 2) return;
var i = 0;
setInterval(function () {
items[i].classList.remove('is-active');
i = (i + 1) % items.length;
items[i].classList.add('is-active');
}, 5000);
}
function fetchCart() {
return fetch(routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
}
function updateBadge(cart) {
$all('[data-rw-cart-badge]').forEach(function (b) {
b.textContent = cart.item_count;
b.hidden = cart.item_count === 0;
});
}
function renderCart(cart) {
updateBadge(cart);
var list = $('[data-rw-cart-items]');
var foot = $('[data-rw-cart-foot]');
var count = $('[data-rw-cart-count]');
if (!list) return;
if (count) count.textContent = cart.item_count === 0 ? 'Your bag is empty' : cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
if (!cart.items.length) {
list.innerHTML = '<div class="rw-drawer__empty">Nothing here yet. Go get smooth.</div>';
if (foot) foot.hidden = true;
return;
}
list.innerHTML = cart.items.map(function (item) {
var img = item.image ? '<img src="' + esc(item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="">' : '';
var opts = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="rw-muted">' + esc(item.variant_title) + '</p>' : '';
var props = '';
if (item.properties) {
Object.keys(item.properties).forEach(function (k) {
var v = item.properties[k];
if (v && k.charAt(0) !== '_') props += '<p class="rw-muted"><strong>' + esc(k) + ':</strong> ' + esc(v) + '</p>';
});
}
var deals = (item.line_level_discount_allocations || []).map(function (d) {
var t = d.discount_application && d.discount_application.title ? d.discount_application.title : 'Discount';
return '<p class="rw-dline__deal">' + esc(t) + '</p>';
}).join('');
var was = item.original_price !== item.final_price ? ' <s class="rw-muted">' + money(item.original_price) + '</s>' : '';
return '<div class="rw-dline" data-key="' + esc(item.key) + '">' +
'<a class="rw-dline__img" href="' + esc(item.url) + '">' + img + '</a>' +
'<div class="rw-dline__info"><a class="rw-dline__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + opts + props +
'<p><strong>' + money(item.final_price) + '</strong>' + was + '</p>' + deals + '</div>' +
'<div class="rw-dline__side"><button type="button" class="rw-dline__remove" data-rw-line-remove aria-label="Remove">' +
'<svg class="rw-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg></button>' +
'<div class="rw-stepper rw-stepper--sm"><button type="button" data-rw-line-step="-1" aria-label="Decrease">−</button>' +
'<input type="number" min="0" value="' + item.quantity + '" data-rw-line-qty aria-label="Quantity">' +
'<button type="button" data-rw-line-step="1" aria-label="Increase">+</button></div></div></div>';
}).join('');
if (foot) foot.hidden = false;
var total = $('[data-rw-cart-total]');
if (total) total.textContent = money(cart.total_price);
var savings = $('[data-rw-cart-savings]');
if (savings) {
if (cart.total_discount > 0) {
savings.textContent = 'You save ' + money(cart.total_discount) + ' with your pricing';
savings.hidden = false;
} else {
savings.hidden = true;
}
}
}
function refreshCart() { return fetchCart().then(renderCart); }
function changeLine(key, qty) {
return fetch(routes.cartChange, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
}).then(function (r) { return r.json(); }).then(renderCart);
}
function addToCart(payload) {
return fetch(routes.cartAdd, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify(payload)
}).then(function (r) {
return r.json().then(function (data) {
if (!r.ok) throw new Error(data.description || data.message || 'Could not add to bag');
return data;
});
});
}
function initCartDrawer() {
$all('[data-rw-cart-open]').forEach(function (b) {
b.addEventListener('click', function (e) {
if (document.body.classList.contains('template-cart')) return;
e.preventDefault();
closeDrawer('rw-menu-drawer');
refreshCart();
openDrawer('rw-cart-drawer');
});
});
$all('[data-rw-cart-close]').forEach(function (b) {
b.addEventListener('click', function () { closeDrawer('rw-cart-drawer'); });
});
var list = $('[data-rw-cart-items]');
if (list) {
list.addEventListener('click', function (e) {
var line = e.target.closest('.rw-dline');
if (!line) return;
var key = line.getAttribute('data-key');
var input = line.querySelector('[data-rw-line-qty]');
if (e.target.closest('[data-rw-line-remove]')) changeLine(key, 0);
var step = e.target.closest('[data-rw-line-step]');
if (step) changeLine(key, parseInt(input.value, 10) + parseInt(step.getAttribute('data-rw-line-step'), 10));
});
list.addEventListener('change', function (e) {
if (!e.target.matches('[data-rw-line-qty]')) return;
var line = e.target.closest('.rw-dline');
var n = parseInt(e.target.value, 10);
changeLine(line.getAttribute('data-key'), isNaN(n) ? 1 : n);
});
}
}
function initMenu() {
$all('[data-rw-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer('rw-menu-drawer'); }); });
$all('[data-rw-menu-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer('rw-menu-drawer'); }); });
}
function initQuickAdd() {
document.addEventListener('click', function (e) {
var btn = e.target.closest('[data-rw-quick-add]');
if (!btn) return;
e.preventDefault();
btn.disabled = true;
var title = btn.closest('.rw-card') ? btn.closest('.rw-card').querySelector('.rw-card__title').textContent : '';
addToCart({ items: [{ id: parseInt(btn.getAttribute('data-rw-quick-add'), 10), quantity: 1 }] })
.then(function () { toast('Added to your bag: ' + title.trim()); return refreshCart(); })
.catch(function (err) { toast(err.message); })
.then(function () { btn.disabled = false; });
});
}
function initSteppers() {
document.addEventListener('click', function (e) {
var b = e.target.closest('[data-rw-qty-step]');
if (!b) return;
var input = b.parentElement.querySelector('[data-rw-qty]');
if (!input) return;
var min = parseInt(input.min || '0', 10);
var v = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-rw-qty-step'), 10);
input.value = Math.max(min, v);
input.dispatchEvent(new Event('input', { bubbles: true }));
});
}
function initProduct() {
var root = $('[data-rw-product]');
if (!root) return;
var wsFactor = parseFloat(root.getAttribute('data-ws-factor')) || 1;
var form = $('[data-rw-product-form]', root);
var variantInput = form ? $('[data-rw-variant-input]', form) : null;
var qtyInput = form ? $('[data-rw-qty]', form) : null;
var addBtn = form ? $('[data-rw-add]', form) : null;
var retailCents = null;
var mainImg = $('.rw-gallery__img', root);
$all('[data-rw-thumb]', root).forEach(function (t) {
t.addEventListener('click', function () {
if (mainImg) { mainImg.src = t.getAttribute('data-rw-thumb'); mainImg.removeAttribute('srcset'); }
$all('[data-rw-thumb]', root).forEach(function (x) { x.classList.toggle('is-active', x === t); });
});
});
var vol = $('[data-rw-volume]', root);
var tiers = (root.getAttribute('data-tiers') || '').split(',').filter(Boolean).map(function (t) {
var p = t.split(':');
return { q: parseInt(p[0], 10), pct: parseFloat(p[1]) };
}).filter(function (t) { return !isNaN(t.q); }).sort(function (a, b) { return a.q - b.q; });
function activeTier(q) {
var a = tiers[0] || { q: 1, pct: 0 };
tiers.forEach(function (t) { if (q >= t.q) a = t; });
return a;
}
function updateVolume() {
if (!vol || retailCents == null || !tiers.length) return;
var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
var base = retailCents * wsFactor;
var t = activeTier(q);
var unit = Math.round(base * (100 - t.pct) / 100);
$all('[data-rw-tier-qty]', vol).forEach(function (row) {
var rq = parseInt(row.getAttribute('data-rw-tier-qty'), 10);
var rp = parseFloat(row.getAttribute('data-rw-tier-pct'));
row.classList.toggle('is-active', rq === t.q);
var u = $('[data-rw-tier-unit]', row);
if (u) u.textContent = money(Math.round(base * (100 - rp) / 100)) + ' ea';
});
$('[data-rw-vol-line]', vol).textContent = q + ' at ' + money(unit) + ' each';
$('[data-rw-vol-pct]', vol).textContent = t.pct + '% off';
var save = Math.round(base * q) - unit * q;
var saveEl = $('[data-rw-vol-save]', vol);
saveEl.hidden = save <= 0;
saveEl.textContent = 'Save ' + money(save);
$('[data-rw-vol-total]', vol).textContent = money(unit * q);
}
if (vol) {
vol.addEventListener('click', function (e) {
var row = e.target.closest('[data-rw-tier-qty]');
if (!row || !qtyInput) return;
qtyInput.value = row.getAttribute('data-rw-tier-qty');
updateVolume();
});
}
if (qtyInput) qtyInput.addEventListener('input', updateVolume);
var chips = $all('[data-rw-variant]', root);
var activeChip = chips.filter(function (c) { return c.classList.contains('is-active'); })[0];
if (activeChip) retailCents = parseInt(activeChip.getAttribute('data-price'), 10);
if (retailCents == null) retailCents = parseInt(root.getAttribute('data-retail'), 10) || 0;
chips.forEach(function (chip) {
chip.addEventListener('click', function () {
chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
if (variantInput) variantInput.value = chip.getAttribute('data-rw-variant');
retailCents = parseInt(chip.getAttribute('data-price'), 10);
var available = chip.getAttribute('data-available') === 'true';
if (addBtn && !form.hasAttribute('data-rw-bulk')) {
addBtn.disabled = !available;
addBtn.textContent = available ? 'Add to bag' : 'Sold out';
}
var now = $('[data-rw-price-now]', root);
var was = $('[data-rw-price-was]', root);
if (now) now.textContent = money(Math.round(retailCents * wsFactor));
if (was) was.textContent = money(retailCents);
var img = chip.getAttribute('data-image');
if (img && mainImg) { mainImg.src = img; mainImg.removeAttribute('srcset'); }
var url = new URL(window.location.href);
url.searchParams.set('variant', chip.getAttribute('data-rw-variant'));
history.replaceState(null, '', url.toString());
updateVolume();
});
});
updateVolume();
var mix = $('[data-rw-mix]', root);
if (mix) {
var total = parseInt(mix.getAttribute('data-total'), 10) || 25;
var inputs = $all('[data-rw-mix-input]', mix);
var soldOut = addBtn && addBtn.hasAttribute('data-soldout');
var sum = function () { return inputs.reduce(function (s, i) { return s + (parseInt(i.value, 10) || 0); }, 0); };
var updateMix = function () {
var picked = sum();
var remaining = total - picked;
$('[data-rw-mix-count]', mix).textContent = picked + ' of ' + total + ' chosen · ' + (remaining > 0 ? remaining + ' to go' : 'all set');
$('[data-rw-mix-count]', mix).classList.toggle('is-ready', remaining === 0);
$('[data-rw-mix-bar]', mix).style.width = (picked / total * 100) + '%';
$('[data-rw-mix-property]', mix).value = inputs.filter(function (i) { return (parseInt(i.value, 10) || 0) > 0; })
.map(function (i) { return i.value + ' x ' + i.getAttribute('data-name'); }).join(', ');
if (addBtn) {
addBtn.disabled = remaining !== 0 || soldOut;
addBtn.textContent = soldOut ? 'Sold out' : remaining > 0 ? 'Choose ' + remaining + ' more can' + (remaining === 1 ? '' : 's') : 'Add to bag';
}
$all('[data-rw-mix-step="1"]', mix).forEach(function (b) { b.disabled = remaining <= 0; });
};
var clamp = function (input) {
var others = sum() - (parseInt(input.value, 10) || 0);
var v = Math.max(0, parseInt(input.value, 10) || 0);
input.value = Math.min(v, total - others);
};
mix.addEventListener('click', function (e) {
var b = e.target.closest('[data-rw-mix-step]');
if (!b) return;
var input = b.parentElement.querySelector('[data-rw-mix-input]');
input.value = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-rw-mix-step'), 10);
clamp(input);
updateMix();
});
inputs.forEach(function (i) { i.addEventListener('input', function () { clamp(i); updateMix(); }); });
updateMix();
}
if (form) {
form.addEventListener('submit', function (e) {
e.preventDefault();
if (addBtn) addBtn.disabled = true;
var fd = new FormData(form);
var item = { id: parseInt(fd.get('id'), 10), quantity: Math.max(1, parseInt(fd.get('quantity'), 10) || 1) };
var props = {};
fd.forEach(function (v, k) {
var m = k.match(/^properties\[(.+)\]$/);
if (m && v) props[m[1]] = v;
});
if (Object.keys(props).length) item.properties = props;
var title = ($('.rw-product__title', root) || {}).textContent || '';
addToCart({ items: [item] })
.then(function () {
toast('Added to your bag: ' + title.trim());
return refreshCart().then(function () { openDrawer('rw-cart-drawer'); });
})
.catch(function (err) { toast(err.message); })
.then(function () {
if (addBtn) addBtn.disabled = false;
if (mix) {
$all('[data-rw-mix-input]', mix).forEach(function (i) { i.value = 0; });
var firstInput = $('[data-rw-mix-input]', mix);
if (firstInput) firstInput.dispatchEvent(new Event('input'));
}
});
});
}
}
function initAccount() {
var wrap = $('[data-rw-account]');
if (!wrap) return;
var btn = $('[data-rw-account-toggle]', wrap);
var menu = $('[data-rw-account-menu]', wrap);
function close() { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
btn.addEventListener('click', function (e) {
e.stopPropagation();
var open = menu.hidden;
menu.hidden = !open;
btn.setAttribute('aria-expanded', String(open));
if (open) { var first = menu.querySelector('a'); if (first) first.focus(); }
});
document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { close(); btn.focus(); } });
}
function initVideos() {
document.addEventListener('click', function (e) {
var play = e.target.closest('.rw-video__play');
if (!play) return;
var frame = play.closest('[data-rw-video]');
var id = frame.getAttribute('data-rw-video');
var iframe = document.createElement('iframe');
iframe.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1';
iframe.title = frame.getAttribute('data-title') || 'Training video';
iframe.allow = 'autoplay; fullscreen; picture-in-picture';
iframe.allowFullscreen = true;
frame.innerHTML = '';
frame.appendChild(iframe);
});
}
function initCookieSettings() {
$all('[data-rw-cookie-settings]').forEach(function (b) {
b.addEventListener('click', function () {
if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
window.privacyBanner.showPreferences();
} else {
toast('Cookie settings are not available right now.');
}
});
});
}
document.addEventListener('DOMContentLoaded', function () {
initAnnouncements();
initMenu();
initCartDrawer();
initQuickAdd();
initSteppers();
initProduct();
initAccount();
initVideos();
initCookieSettings();
});
})();
